export default __webpack_public_path__ + "static/media/1577.34a02b77.png";